import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import {
	IAssigneeTeam,
	IAssigneeUser,
} from '@shared/interfaces/selectable-options.interfaces';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'input-type-select',
	templateUrl: './input-type-select.component.html',
	styleUrls: ['./input-type-select.component.scss'],
	imports: [MatProgressSpinnerModule, MatIconModule],
})
export class InputTypeSelectComponent implements OnInit, OnDestroy {
	@Input() label: string;
	@Input() placeholder = 'Choose an option';
	@Input() value: IAssigneeTeam | IAssigneeUser;
	@Input() loading: boolean;
	@Input() blurEvent: Subject<void>;

	focused = false;

	private subscription = new Subscription();

	ngOnInit() {
		this.subscription = this.blurEvent.subscribe(() => (this.focused = false));
	}

	chooseRightName(): string {
		if (this.value && 'name' in this.value) {
			return this.value.name;
		}
		if (this.value && 'firstName' in this.value) {
			return `${this.value.firstName} ${this.value.lastName}`;
		}
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}
}
